import { constants, typographyStyles } from "@newsela/angelou";

const { textXS } = typographyStyles.fontSize;

export const shareCtaContainerCss = {
  maxWidth: "420px",
};

export const shareCtaDividerCss = {
  display: "grid",
  gridTemplateColumns: "1fr auto 1fr",
  gap: "1ch",
  alignItems: "center",

  marginTop: "1rem",
  color: constants.colors.ui.neutral[300],
  ...textXS,
  fontWeight: 700,
  letterSpacing: "1px",
  lineHeight: "1rem",
  textTransform: "uppercase",

  "::after, ::before": {
    content: '""',
    borderTop: "1px solid currentColor",
  },
};

export const shareCtaPrintAssignmentCss = {
  root: {
    justifyContent: "center",
    marginTop: "1.5rem",
    width: "100%",

    // when disabled, look for all three attributes
    ':not([href])[aria-disabled="true"][role="link"]': {
      cursor: "not-allowed",
      opacity: "0.4",
    },
  },
  Icon: {
    root: {
      "--icon-stroke-width": 3,
      transform: "translateY(-2px)",
    },
  },
};
